import { useContext, useEffect } from 'react';
import { useGeneralRoutes } from '@namespace/cms';
import { COLOR_SCHEME_LIGHT } from '@namespace/helpers';
import { useHistory } from '@namespace/router';
import { useColorScheme } from '@namespace/themes';
import { TelegramAppContext } from '../../store/telegram-app/context';

const useInitTelegramApp = () => {
  const [, { SET_INIT_DATA }] = useContext(TelegramAppContext);
  const {
    colorScheme: { selectedColorMode }
  } = useColorScheme();
  const { initData } = window.Telegram?.WebApp || {};
  const { goBack, push } = useHistory();
  const { deposit } = useGeneralRoutes();

  useEffect(() => {
    if (initData) {
      SET_INIT_DATA({
        initData
      });
    }
  }, [initData, SET_INIT_DATA]);

  useEffect(() => {
    if (initData) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.SettingsButton?.show();
      window.Telegram.WebApp.BackButton?.show?.();

      window.Telegram.WebApp.expand();

      window.Telegram.WebApp.enableClosingConfirmation();

      window.Telegram.WebApp.onEvent('settingsButtonClicked', () =>
        push(deposit)
      );
      window.Telegram.WebApp.onEvent('backButtonClicked', goBack);
    }
  }, [initData]);

  useEffect(() => {
    if (initData) {
      const IS_LIGHT_THEME = selectedColorMode === COLOR_SCHEME_LIGHT;
      // Set button colors
      const textColor = IS_LIGHT_THEME ? '#ededed' : '#bebebe';
      const backgroundColor = IS_LIGHT_THEME ? '#005' : '#040613';
      window.Telegram.WebApp.BackButton?.setParams?.({
        text_color: textColor
      });
      window.Telegram.WebApp.SettingsButton?.setParams?.({
        text_color: textColor
      });
      window.Telegram.WebApp.CloseButton?.setParams?.({
        text_color: textColor
      });

      // Set header and footer colors
      window.Telegram.WebApp.setHeaderColor?.(backgroundColor, textColor);
    }
  }, [initData, selectedColorMode]);
};

export default useInitTelegramApp;
